export default __webpack_public_path__ + "static/media/0x430ef9263e76dae63c84292c3409d61c598e9682.8c832970.webp";